const ProductAngel = {
  //产品天使
  path: 'product-angel',
  component: () => import("@/views/member/product-angel/product-angel"),
  meta: {
    tabBar: 'home'
  },
  children: [
    {
      path: 'product-income',
      component: () => import("@/views/member/product-angel/product-income"),
      meta: {
        tabBar: false
      },
    },
    {
      path: 'product-statistics',
      component: () => import("@/views/member/product-angel/product-statistics"),
      meta: {
        tabBar: false
      },
    },
    {
      path: 'product-sales-data',
      component: () => import("@/views/member/product-angel/product-sales-data"),
      meta: {
        tabBar: false
      },
    },
  ]
};

export default ProductAngel;
